export const EASY_BONDPAY_LEARN_MORE_LINK =
  'https://snug.com/partner/easybondpay/'
